<template>
    <div>
        <div v-if="model">
            <rkm-form
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input-autocomplete
                            :disabled="disableField()"
                            :repository="repositories.material"
                            :request-query-string-params="queryStringParams.material"
                            :search-fields="fields.autocomplete.material"
                            :validations="validations.material"
                            label="Item"
                            :text-field="function(item) {
                                const programas = [item.altoCusto, item.programaRemedioEmCasa, item.acaoJudicial, item.remume];
                                const programasSeparados = programas.filter(Boolean).join(', ');
                                const programasFormatados = programasSeparados ? `(${programasSeparados})` : '';

                                return `${item.descricaoCompleta} ${programasFormatados}`
                            }"
                            v-model="model.item.material"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :value="model.item.estoque"
                            disabled
                            label="Estoque"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    :disabled="!model.item.material"
                                    @click.stop="loadEstoque"
                                    color="primary"
                                    title="Atualizar estoque"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="sync-alt" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            :validations="validations.dataDispensacao"
                            :max-date="form.dataAtual"
                            label="Data da dispensação"
                            right
                            v-model="model.item.dispensadoEm"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input
                            :disabled="disableField()"
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.item.quantidade"
                        >
                            <rkm-input-group-append
                                slot="append"
                            >
                                <rkm-form-input
                                    disabled
                                    name="Unidade de medida"
                                    v-model="unidadeMedida"
                                />
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :disabled="disableField()"
                            :label="false"
                            :validations="validations.intervaloTempo"
                            name="Intervalo"
                            type="number"
                            v-model="model.item.intervaloTempo"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>
                                    a cada
                                </rkm-input-group-text>
                            </rkm-input-group-prepend>

                            <rkm-input-group-append slot="append">
                                <rkm-form-select
                                    :disabled="disableField()"
                                    :options="form.unidadesMedidaTempo"
                                    :validations="validations.intervaloTempoId"
                                    name="Unidade de medida intervalo"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.item.intervaloMedidaTempoId"
                                    value-field="id"
                                />
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :disabled="disableField()"
                            :validations="validations.duranteTempo"
                            label="Durante"
                            type="number"
                            v-model="model.item.duranteTempo"
                        >
                            <rkm-input-group-append
                                class="w-50"
                                slot="append"
                            >
                                <rkm-form-input
                                    class="w-100"
                                    disabled
                                    v-model="duranteText"
                                />
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="1">
                        <rkm-form-input
                            :disabled="form.posologiaIsObrigatorio || isPendente"
                            :validations="validations.prescrito"
                            label="Prescrito"
                            type="number"
                            v-model="model.item.prescrito"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :disabled="!model.item.material && form.posologiaIsObrigatorio || !model.item.prescrito && form.posologiaIsObrigatorio"
                            :validations="validations.entregue"
                            @change="handleChangeEntregue()"
                            label="Entregue"
                            type="number"
                            v-model="model.item.entregue"
                        >
                            <rkm-input-group-append
                                v-if="model.item.material && model.item.possuiEntradaComLote"
                                slot="append"
                            >
                                <rkm-button
                                    :disabled="!quantidadeEntregueValida || !model.item.prescrito"
                                    @click.stop="$refs.ModalLote.open(model.item.entradaItens, onChangeLotes)"
                                    title="Visualizar lotes"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="box-open" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            :validations="validations.proximaRetirada"
                            :max-date="maxDataProximaRetirada"
                            label="Próxima retirada"
                            right
                            v-model="model.item.proximaRetirada"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="validations.observacao"
                            label="Observações"
                            v-model="model.item.observacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="lotes.length > 0">
                    <rkm-col>
                        <rkm-area type="fieldset" title="Lotes escolhidos">
                            <rkm-table
                                :fields="fields.lotes"
                                :items="lotes"
                                hide-filters
                                hide-pagination
                            />
                        </rkm-area>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col class="text-right">
                        <rkm-button
                            :label="false"
                            @click="save()"
                            color="primary"
                            class="mt-0"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            class="mt-0"
                            @click.stop="resetMaterial"
                            :disabled="!model.item.material"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <ModalLote
                :model="model.item"
                quantidade-key="entregue"
                ref="ModalLote"
            />

            <ModalPermissao
                ref="ModalPermissao"
                @handlePermission="handlePermission"
                @resetMaterial="resetMaterial"
            />
        </div>
    </div>
</template>

<script>
// Components
import ModalLote from '@/components/almoxarifado/components/lote/Modal'
import ModalPermissao from '@/components/farmacia/components/receita/item/ModalPermissao'

// Mixins
import { repository, object, error } from '@/mixins'

//Enums
import medidaTempo from '@/enums/cadastro/medidaTempo'

//Vuex
import { mapActions } from 'vuex'

//Moment
import moment from 'moment'

import functions from '@/utils/farmacia/functions'

export default {
    components: { ModalLote, ModalPermissao },
    computed: {
        lotes() {

            if (!this.model.item.material || !this.model.item.possuiEntradaComLote) return []

            return this.model.item.entradaItens.filter(l => parseInt(l.quantidadeSaida) > 0)
        },
        fields() {
            return {
                autocomplete: {
                    material: [
                        { key: "codigo_material", searchable: true },
                        { key: "descricao", searchable: true },
                    ],
                },
                lotes: [
                    { key: "lote", label: "Lote" },
                    { key: "validadeLote", label: "Validade" },
                    { key: "quantidadeSaida", label: "Quantidade" },
                ]
            }
        },
        queryStringParams() {

            return {
                material: {
                    is_programa_remedio_em_casa: this.model.isRemedioEmCasa,
                    almoxarifado_check_controle_estoque: true,
                    load_entradas: false,
                }
            }
        },
        validations() {

            return {
                material: { required: true },
                dataDispensacao: { required: true },
                quantidade: { required: this.form.posologiaIsObrigatorio ? true : false, min_value: 0, min: 0 },
                entregue: { required: true, min_value: 1, min: 1 },
                intervaloTempo: { required: this.form.posologiaIsObrigatorio ? true : false, min_value: 1, min: 1 },
                intervaloTempoId: { required: this.form.posologiaIsObrigatorio ? true : false },
                duranteTempo: { required: this.form.posologiaIsObrigatorio ? true : false, min: 1, min_value: 1, max_value: this.model.limiteDiasPrescricaoMedicamento },
                prescrito: { required: true, numeric: true },
                proximaRetirada: { required: true },
                observacao: { min:3, max: 300 },
            }
        },
        unidadeMedida() {

            if (!this.model.item.material) return '...';

            return this.model.item.material.apresentacaoUnidadeMedidaNome
        },
        quantidadeEntregueValida() {

            if (!this.model.item.entregue) {

                return false
            }

            const quantidade = parseInt(this.model.item.entregue)

            return quantidade > 0
        },
        maxDataProximaRetirada() {
            const [dia, mes, ano] = (this.form.dataAtual || '').split('/');
            const data = new Date(Number(ano), Number(mes) - 1, Number(dia)); // ← modo local

            if (isNaN(data)) return null;

            const dias = parseInt(this.model.limiteDiasPrescricaoMedicamento, 10);
            data.setDate(data.getDate() + (isNaN(dias) ? 180 : dias));

            const diaFormatado = String(data.getDate()).padStart(2, '0');
            const mesFormatado = String(data.getMonth() + 1).padStart(2, '0');
            const anoFormatado = data.getFullYear();

            return `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
        }
    },
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            dispensacao: this.getConectaSusRepository('farmacia.dispensacao')
        }

        this.addWatchers()
        this.handleChangeEntregue()
    },
    data: () => ({
        duranteText: 'Dia(s)',
        enums: { medidaTempo },
        unwatchers: {
            unwatchMaterial: null,
            unwatchQuantidade: null,
            unwatchIntervaloTempo: null,
            unwatchIntervaloMedidaTempo: null,
            unwatchDuranteTempo: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        ...functions,
        disableField() {

            return this.model && this.model.item && Number(this.model.item.id) > 0
        },
        onChangeLotes() {

            const proximaRetirada = this.getDateProximaRetirada(this.model.item)
            this.model.item.proximaRetirada = proximaRetirada && proximaRetirada.toDate()
        },
        handleChangeEntregue() {

            this.selectEntradaItens()
            const proximaRetirada = this.getDateProximaRetirada(this.model.item)

            this.model.item.proximaRetirada = proximaRetirada && proximaRetirada.toDate()
        },
        save() {
            this.$refs.RkmForm.validate()
            .then(valid => {
                    if (!valid) return

                    if (!this.verificaQuantidadeMaximaPorLote()) return

                    this.$emit('save', this.model.item)
                    this.$refs.RkmForm.resetValidator()
                })
        },
        calculate() {

            const item = this.model.item

            if (item.saldo) {

                item.entregue = item.saldo > item.estoque ? item.estoque : item.saldo

                this.selectEntradaItens()

                return
            }

            const quantidade = parseInt(item.quantidade)
            const intervaloTempo = parseInt(item.intervaloTempo)
            const duranteTempo = parseInt(item.duranteTempo)

            if (!isNaN(quantidade) && !isNaN(intervaloTempo) && item.intervaloMedidaTempoId && !isNaN(duranteTempo)) {

                const multiplier = this.getUnidadeMedidaTempoMultiplier(item.intervaloMedidaTempoId)
                const materialQuantidade = parseFloat(item.material.quantidade)

                const result = Math.ceil(quantidade * multiplier / intervaloTempo * duranteTempo / materialQuantidade)

                item.prescrito = result
                item.entregue = result > item.estoque ? item.estoque : result

                this.selectEntradaItens()
            }
            else {

                item.prescrito = null
                item.entregue = null
            }
        },
        setDuranteTempoText() {

            const eMedidaTmp = this.enums.medidaTempo

            if ([eMedidaTmp.MINUTOS, eMedidaTmp.HORAS, eMedidaTmp.DIAS].includes(this.model.item.intervaloMedidaTempoId)) {

                this.duranteText = 'Dia(s)'

            } else if (eMedidaTmp.SEMANAS === this.model.item.intervaloMedidaTempoId) {

                this.duranteText = 'Semana(s)'

            } else if (eMedidaTmp.MESES === this.model.item.intervaloMedidaTempoId) {

                this.duranteText = 'Mes(es)'
            }
        },
        loadEstoque() {

            this.model.item.possuiEntradaComLote = false
            this.model.item.estoque = 0
            this.model.item.entradaItens = []
            this.model.item.escolheuEntradaItemManualmente = false

            this.setLoading()

            this.repositories.material.getEstoque(this.model.item.material.id)
                .then(({ data }) => {

                    this.model.item.possuiEntradaComLote = data.possuiEntradaComLote

                    this.model.item.estoque = data.total

                    this.model.item.programa = data.programa

                    this.model.item.entradaItens = data.porEntrada.map(estoqueEntrada => {

                        estoqueEntrada.quantidadeSaida = 0

                        return estoqueEntrada
                    })

                    this.calculate()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectEntradaItens() {

            if (!this.model.item.material || !this.quantidadeEntregueValida) return

            this.model.item.escolheuEntradaItemManualmente = false

            this.model.item.entradaItens.map(e => e.quantidadeSaida = 0)

            let quantidade = parseInt(this.model.item.entregue)
            let i = 0

            while (quantidade > 0) {

                const entradaItem = this.model.item.entradaItens[i]
                const estoque = parseInt(entradaItem.estoque)

                if (quantidade > estoque) {

                    entradaItem.quantidadeSaida = estoque
                    quantidade -= estoque
                }
                else {

                    entradaItem.quantidadeSaida = quantidade
                    quantidade = 0
                }

                i++
            }
        },
        handlePermission(supervisorId){

            this.model.item.supervisorId = supervisorId
            this.loadEstoque()
        },
        verificaQuantidadeMaximaPorLote() {
            const eMedidaTmp = this.enums.medidaTempo;
            const dispensadoEm = moment(this.model.item.dispensadoEm, 'YYYY-MM-DD')
            const dataSaida = dispensadoEm.clone();

            switch (this.model.item.intervaloMedidaTempoId) {
                case eMedidaTmp.SEMANAS:
                    dataSaida.add(this.model.item.duranteTempo, 'weeks');
                    break;
                case eMedidaTmp.MESES:
                    dataSaida.add(this.model.item.duranteTempo, 'months');
                    break;
                case eMedidaTmp.ANOS:
                    dataSaida.add(this.model.item.duranteTempo, 'years');
                    break;
                default:
                    dataSaida.add(this.model.item.duranteTempo, 'days');
                    break;
            }

            let quantidadeValida = true;
            this.lotes.forEach(item => {
                const validadeLote = moment(item.validadeLote, "DD/MM/YYYY");

                if(dataSaida.isAfter(validadeLote)){

                    const confirm = async () => {
                        this.$refs.ModalLote.open(this.model.item.entradaItens, this.onChangeLotes)
                    }

                    const exit = async () => {
                        this.resetMaterial()
                    }

                    const msg = "O lote deste medicamento não pode ser dispensado, pois a quantidade consumida ultrapassará o prazo de validade. <br/> Deseja selecionar outro lote?";

                    this.showConfirmation(msg, confirm, exit)
                    quantidadeValida = false;
                }
            });

            return quantidadeValida;
        },

        getLoteMaisProximoValidade(){
            this.lotes.forEach(item => {
                item.validadeMoment = moment(item.validadeLote, "DD/MM/YYYY");
            });
            const dataMinima = moment.min(this.lotes.map(item => item.validadeMoment));
            const itensDataMinima = this.lotes.filter(item => item.validadeMoment.isSame(dataMinima, 'day'));

            const loteMaisProximo = itensDataMinima.reduce((menorLote, atual) => {
                if (parseInt(atual.estoque) < parseInt(menorLote.estoque)) {
                    return atual;
                }
                return  menorLote;
            });

            return loteMaisProximo;
        },
        resetMaterial() {

            this.model.item.material = null
        },
        addWatchers() {

            this.unwatchers.unwatchMaterial = this.$watch('model.item.material', (newMaterial, oldMaterial) => {

                if (!this.model) return

                this.model.item.estoque = 0
                this.model.item.entradaItens = []
                this.model.item.escolheuEntradaItemManualmente = false
                this.model.item.entregue = null

                const newMaterialId = newMaterial && newMaterial.id
                const oldMaterialId = oldMaterial && oldMaterial.id

                if (!newMaterial) return

                if (newMaterialId !== oldMaterialId) {

                    this.setLoading()

                    const params = {
                        'material_id': newMaterial.id,
                        'paciente_id': this.form.paciente.id
                    }

                    this.repositories.dispensacao.getUltimaRetirada({params})
                        .then(({ data }) => {

                            const proximaRetirada = moment(data.proximaRetirada, 'DD/MM/YYYY')
                            const dataAtual = moment(this.form.dataAtual, 'DD/MM/YYYY')

                            if (proximaRetirada.isAfter(dataAtual)) {

                                if (this.form.medicamentoSupervisorDispensar) {

                                    const confirm = async () => {

                                        this.$refs.ModalPermissao.open()
                                    }

                                    const cancel = async () => { this.resetMaterial() }

                                    const msg = `A data da próxima retirada do item selecionado é ${data.proximaRetirada},
                                    para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                                    this.showConfirmation(msg, confirm, cancel)
                                } else {

                                    this.showConfirmation(
                                        `A data da próxima retirada do item selecionado é ${data.proximaRetirada}, deseja continuar?`,
                                        async () => {

                                            this.loadEstoque()
                                        },
                                        async () => this.model.item.material = null
                                    )
                                }
                            }
                            else {

                                this.loadEstoque()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
                else {

                    this.loadEstoque()
                }
            })

            this.unwatchers.unwatchQuantidade = this.$watch('model.item.quantidade', () => {

                if (!this.model) return

                this.calculate()
            })

            this.unwatchers.unwatchIntervaloTempo = this.$watch('model.item.intervaloTempo', () => {

                if (!this.model) return

                this.calculate()
            })

            this.unwatchers.unwatchIntervaloMedidaTempo = this.$watch('model.item.intervaloMedidaTempoId', () => {

                if (!this.model) return

                const proximaRetirada = this.getDateProximaRetirada(this.model.item)

                this.model.item.proximaRetirada = proximaRetirada && proximaRetirada.toDate()

                this.setDuranteTempoText()
                this.calculate()
            })

            this.unwatchers.unwatchDuranteTempo = this.$watch('model.item.duranteTempo', () => {

                if (!this.model) return

                this.calculate()
                const proximaRetirada = this.getDateProximaRetirada(this.model.item)

                this.model.item.proximaRetirada = proximaRetirada && proximaRetirada.toDate()
                
            })
        },
        removeWatchers() {

            this.unwatchers.unwatchMaterial()
            this.unwatchers.unwatchQuantidade()
            this.unwatchers.unwatchIntervaloTempo()
            this.unwatchers.unwatchIntervaloMedidaTempo()
            this.unwatchers.unwatchDuranteTempo()
        }
    },
    mixins: [repository, object, error],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
        isPendente: { type: Boolean, default: false },
    }
}
</script>